<template>
  <v-dialog v-model="show" max-width="1200" persistent scrollable>
    <v-card>
      <v-card-title>
        Products in Catalog
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <div class="mb-4">
          <div class="d-flex align-center mb-2">
            <strong class="mr-2">Catalog:</strong>
            <span>{{ catalog ? catalog.name : '' }}</span>
          </div>
          <div class="d-flex align-center">
            <strong class="mr-2">Products:</strong>
            <span>{{ (catalog && catalog.productCount) || 0 }}</span>
          </div>
        </div>

        <!-- Search Box -->
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          clearable
          hide-details
          class="mb-4"
          placeholder="Enter product title to search..."
        ></v-text-field>

        <v-data-table
          :headers="headers"
          :items="filteredProducts"
          :items-per-page="itemsPerPage"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100, -1],
            'items-per-page-text': 'Products per page:',
            'show-current-page': true,
            'show-first-last-page': true,
          }"
          class="elevation-1"
        >
          <template v-slot:[`item.image`]="{ item }">
            <v-avatar size="50" tile class="my-2">
              <img :src="parseImageCatalog(item)" :alt="item.title" />
            </v-avatar>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import imageHelpers from '@/helpers/image';

export default {
  name: 'ProductsDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    catalog: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Image', value: 'image', sortable: false, width: '80px' },
        { text: 'Title', value: 'title', sortable: false },
        { text: 'Retailer ID', value: 'googleProductId', sortable: false },
      ],
      search: '',
      itemsPerPage: 50,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    products() {
      return this.catalog ? this.catalog.products_detail || [] : [];
    },
    filteredProducts() {
      if (!this.search) {
        return this.products;
      }
      const searchLower = this.search.toLowerCase().trim();
      return this.products.filter(product => {
        const title = (product.title || '').toLowerCase();
        return title.includes(searchLower);
      });
    },
  },
  methods: {
    parseImageCatalog(catalog) {
      if (!catalog) return require('@/assets/images/no-image.png');
      const imageObj = catalog.image || (catalog.imageSrcs && catalog.imageSrcs[0]);
      const imageSrc = typeof imageObj === 'string' ? imageObj : imageObj?.src || '';
      if (!imageSrc) return require('@/assets/images/no-image.png');
      return imageHelpers.url(imageSrc, { width: 320, height: 320 });
    },
    close() {
      this.$emit('close');
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped></style>
